function InitializeAdvancedRadiusResults() {
    $('.clear-all-single').click(function() {
        if ($(this).text().trim() === "Clear all") {
            $('.clear-all-single').closest('table').find('input:checkbox').prop('checked', false);
            $(this).text('Check all');
        } else {
            $('.clear-all-single').closest('table').find('input:checkbox').prop('checked', true);
            $(this).text('Clear all');
        }
    });

    $('.match-result-input').click(function() {
        UpdateRadiusResultsSelections();
    });

    UpdateRadiusResultsSelections();
}

function UpdateRadiusResultsSelections() {
    $('#MatchSelections').val();
    var matchSelections = '';
    $.each($('.radius-single-results input:checkbox:checked'), function (i, v) {
        var currentSingleMatch = $(this);
        matchSelections = matchSelections + currentSingleMatch.data('latitude') + '|' + currentSingleMatch.data('longitude') + '|' + currentSingleMatch.data('maxdistance') + '|' + currentSingleMatch.data('address') + '|' + currentSingleMatch.data('city') + '|' + currentSingleMatch.data('state') + '|' + currentSingleMatch.data('zipcode') + '|' + currentSingleMatch.data('keycode') + '|' + currentSingleMatch.data('requestedcount') + '~';
    });
    $.each($('.radius-multiple-results input:checkbox:checked'), function (i, v) {
        var currentMultipleMatch = $(this);
        matchSelections = matchSelections + currentMultipleMatch.data('latitude') + '|' + currentMultipleMatch.data('longitude') + '|' + currentMultipleMatch.data('maxdistance') + '|' + currentMultipleMatch.data('address') + '|' + currentMultipleMatch.data('city') + '|' + currentMultipleMatch.data('state') + '|' + currentMultipleMatch.data('zipcode') + '|' + currentMultipleMatch.data('keycode') + '|' + currentMultipleMatch.data('requestedcount') + '~';
    });
    $('#MatchSelections').val(matchSelections);
}



